module.exports = __webpack_public_path__ + "static/media/Clockwork Robot.5a915e71.jpg";